export default __webpack_public_path__ + "infoFirstPart.392937f.png";